import { common as enCommon } from './en/common';
import { common as ptCommon } from './pt/common';

export const resources = {
  en: {
    common: enCommon
  },
  pt: {
    common: ptCommon
  }
} as const;
